module.exports = __webpack_public_path__ + "static/media/step2img4.ef640b26.JPG";